module.exports = __webpack_public_path__ + "static/media/list.1d9c0ccd.svg";